import React from 'react';

export function StartupLoading() {
  return <main style={{ minHeight: '100vh', background: '#050508', color: '#fff', padding: 32 }} role="status">
    <h1>Full Spectrum</h1>
    <p>Opening Full Spectrum…</p>
    <p>If this takes too long, <a style={{ color: '#00f0ff' }} href="/login">return to sign in</a>.</p>
  </main>;
}

export default class StartupBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error('[Full Spectrum startup]', error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main style={{ minHeight: '100vh', background: '#050508', color: '#fff', padding: 32 }} role="alert">
      <h1>Full Spectrum could not open</h1>
      <p>The page did not finish loading. Reload to retrieve the current version.</p>
      <button onClick={() => window.location.reload()}>Reload Full Spectrum</button>
      <p><a style={{ color: '#00f0ff' }} href="/login">Return to sign in</a></p>
      <p><a style={{ color: '#00f0ff' }} href="/downloads">Open private app downloads</a></p>
      <p>If you opened this inside a messaging app, open the same private link in Safari or Chrome.</p>
    </main>;
  }
}
